import { UpdateGroupComponent } from './update.groups/update.groups.component';
import { UpdateUpdaterComponent } from './update.updater/update.updater.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedAppModule } from '../app.module.shared';
import { UpdaterRoutingModule } from './update.routing.module';
import { UpdateCPUBenchmarksComponent } from './update.cpubenchmarks/update.cpubenchmarks.component';
import { UpdateGPUBenchmarksComponent } from './update.gpubenchmarks/update.gpubenchmarks.component';
import { UpdateCommandCenterComponent } from './update.commandcenter/update.commandcenter.component';

@NgModule({
    imports: [
        CommonModule,
        SharedAppModule,
        UpdaterRoutingModule
    ],
    declarations: [
        UpdateUpdaterComponent,
        UpdateCPUBenchmarksComponent,
        UpdateGPUBenchmarksComponent,
        UpdateGroupComponent,
        UpdateCommandCenterComponent
    ]
})
export class UpdaterModule { }
